export default "__VITE_ASSET__DTZsqJkw__"